// MUI
import { Box, Grid, Typography } from "@mui/material";

const UsersMultiSelectFooter = () => {
	return (
		<>
			<Grid item marginTop={-1}>
				<Typography component={"div"} className="regular-pt-sans-pro-narrow-label fs-12" display={"inline"}>
					<Box component={"span"} display={"inline"} sx={{ fontSize: "14px" }}>
						*
						<Box display={"inline"} sx={{ position: "relative", left: "9.5px" }}>
							&quot;Queue&quot; Marked on Pay Plan
						</Box>
					</Box>
				</Typography>
			</Grid>
			<Grid item marginTop={-2}>
				<Typography component={"div"} className="regular-pt-sans-pro-narrow-label fs-12" display={"inline"}>
					<Box component={"span"} display={"inline"} sx={{ fontSize: "14px" }}>
						**
						<Box display={"inline"} sx={{ position: "relative", left: "5px" }}>
							&quot;Queue&quot; Marked on Pay Plan and Member doesn&apos;t belong to any queues
						</Box>
					</Box>
				</Typography>
			</Grid>
		</>
	);
};

export default UsersMultiSelectFooter;
